import { MODES } from "#src/constants/mode.ts";
import { isBoolean } from "#src/util/helpers.js";
import { type ProductTypeInfo, type Product } from "#src/types/Product.ts";
import { PRODUCTS } from "#src/constants/products.ts";

import {
  insuredQuoteData,
  type ModeDataItem,
  type QuoteParams,
  type QuoteRequestParams,
  type RenderRules,
} from "#src/types/QuoteParams.ts";

export interface ReturnOfPremiumProductTypeInfo extends ProductTypeInfo {
  isRopTerm: boolean;
  termLengths: number[];
  requestCategoryGenerator: (termLength: number | null) => string[];
}

function showHealth(conversion: boolean) {
  return !conversion;
}
export default function ReturnOfPremium(): ReturnOfPremiumProductTypeInfo {
  return {
    renderRules(
      _quoteParams,
      options = { conversion: false }
    ): Partial<RenderRules> {
      return {
        saveAge: true,
        termLength: true,
        faceAmount: true,
        insuredHealth: showHealth(options.conversion),
        mode: true,
        state: true,
      };
    },
    get isRopTerm(): boolean {
      return true;
    },
    get type(): Product {
      return PRODUCTS.ROP_TERM;
    },
    get display(): string {
      return "Return of Premium Term";
    },
    get requestCategory(): string {
      return "term.return_of_premium";
    },
    get termLengths(): number[] {
      return [30, 20];
    },
    get defaults(): Partial<QuoteRequestParams> {
      return {
        active_years: 20,
        save_age: false,
        categories: this.requestCategoryGenerator,
      };
    },
    get modes(): ModeDataItem[] {
      return MODES;
    },
    //When is this used?
    requestCategoryGenerator(termLength = null): string[] {
      const reqCatGen = (cat: string, len: number | null) =>
        len ? `${cat}.${len}_year` : cat;
      return [reqCatGen(this.requestCategory, termLength)];
    },
    eAppParser(model): Partial<QuoteParams> {
      let active_years = model?.active_years;
      if (active_years && !this.termLengths.includes(active_years))
        active_years = this.defaults.active_years;
      let saveAge = model.save_age;
      if (!isBoolean(saveAge)) saveAge = this.defaults.save_age;
      return {
        active_years,
        save_age: saveAge,
        face_amount: model?.face_amount || 1000000,
      };
    },
    toQuoteRequest(args): Partial<QuoteRequestParams> {
      return {
        agent: { id: args.agentId },
        compare: false,

        ...insuredQuoteData(args.insured),

        selected_type: args.params.selected_type,
        state: args.params.state,
        categories: this.requestCategoryGenerator(
          args.params.active_years || null
        ),

        mode: args.params.mode,
        save_age: args.params.save_age,
        face_amount: args.params.face_amount,
      };
    },
  };
}
